module.exports = __webpack_public_path__ + "static/media/money.8d25021b.jpeg";